module.exports = __webpack_public_path__ + "static/img/last-page.c0aa5362.svg";